import { render, staticRenderFns } from "./groupCommodity.vue?vue&type=template&id=7525d542&scoped=true&"
import script from "./groupCommodity.vue?vue&type=script&lang=js&"
export * from "./groupCommodity.vue?vue&type=script&lang=js&"
import style0 from "./groupCommodity.vue?vue&type=style&index=0&id=7525d542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7525d542",
  null
  
)

export default component.exports